/**
 * List of container box types
 *
 * @public
 */
export const CONTAINERS: string[] = [
	'dinf',
	'edts',
	'grpl',
	'mdia',
	'meco',
	'mfra',
	'minf',
	'moof',
	'moov',
	'mvex',
	'schi',
	'sinf',
	'stbl',
	'strk',
	'traf',
	'trak',
	'tref',
	'udta',
	'vttc',
]
